import { useApiStore } from "@/stores/api/index.ts";
import getDefaultOpts from "@/store/utils/getDefaultOpts.js";

function updateStore({ getters, commit }, updates) {
  const cats = updates.reduce((acc, item) => {
    if (typeof acc[item.categoryID] === "undefined") {
      acc[item.categoryID] = [];
    }
    acc[item.categoryID].push(item);
    return acc;
  }, {});
  Object.keys(cats).forEach((cat) => {
    cats[cat].forEach(({ path, update, parentCategoryID }) => {
      const parentCategory = getters.category(parentCategoryID);
      const subCategoryIndex = parentCategory.categories.findIndex(
        (item) => item.path === path
      );
      Object.keys(update).forEach((key) => {
        parentCategory.categories[subCategoryIndex][key] = update[key];
      });
      commit("storeCategory", parentCategory);
    });
  });
}

/*
Updates is an array of objects in this form:
[
  {
    path: "/entry/xyz", // path of doc
    parentCategoryID: ""
    categoryID: "",
    updates: {
      field: "value"
    }
  }
]
 */

const patchSubcategoriesBulk = async (module, { updates, opts = {} }) => {
  const api = useApiStore();
  const { dispatch } = module;
  const config = Object.assign(getDefaultOpts(), opts);
  if (config.updateStoreFirst) {
    updateStore(module, updates);
  }
  await dispatch("httpRequest", {
    func: api.patchBulk(updates),
    config,
  });
  if (!config.updateStoreFirst) {
    updateStore(module, updates);
  }
};

export { patchSubcategoriesBulk };
